import { render } from "./PermissionMatrix.vue?vue&type=template&id=30b79aa0&scoped=true"
import script from "./PermissionMatrix.vue?vue&type=script&lang=js"
export * from "./PermissionMatrix.vue?vue&type=script&lang=js"

import "./PermissionMatrix.vue?vue&type=style&index=0&id=30b79aa0&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b79aa0"]])

export default __exports__